// "use client";


// import React from "react";


// const toLower = (s) => String(s || "").toLowerCase().trim();
// const uniqKeepOrder = (arr) => {
// const seen = new Set();
// const out = [];
// for (const x of arr) {
// const k = toLower(x);
// if (!k || seen.has(k)) continue;
// seen.add(k);
// out.push(String(x).trim());
// }
// return out;
// };


// export function HistoryDatalist({ id, values, extras = [] }) {
// const combined = uniqKeepOrder([...(values || []), ...extras]);
// return (
// <datalist id={id}>
// {combined.map((v) => (
// <option key={`${id}-${v}`} value={v} />
// ))}
// </datalist>
// );
// }


// export default HistoryDatalist;


// app/components/ui/HistoryDatalist.jsx
"use client";

import React from "react";

const toLower = (s) => String(s || "").toLowerCase().trim();
const uniqKeepOrder = (arr) => {
  const seen = new Set();
  const out = [];
  for (const x of arr || []) {
    const k = toLower(x);
    if (!k || seen.has(k)) continue;
    seen.add(k);
    out.push(String(x).trim());
  }
  return out;
};

export function HistoryDatalist({ id, values, extras = [] }) {
  const combined = uniqKeepOrder([...(values || []), ...extras]);
  return (
    <datalist id={id}>
      {combined.map((v) => (
        <option key={`${id}-${v}`} value={v} />
      ))}
    </datalist>
  );
}

export default HistoryDatalist;
